import { useDocumentTitle } from "@/hooks/use-document-title";
import { JoinOrganization } from "@/routes/join-organization/JoinOrganization";
import { JoinOrganizationFromInvite } from "@/routes/join-organization/JoinOrganizationFromInvite";
import { type FC } from "react";
import { useParams } from "react-router-dom";

export const JoinOrganizationPage: FC = () => {
    const { inviteId } = useParams();
    useDocumentTitle("Join Organization");

    return (
        <div className="flex size-full grow flex-col items-center justify-center px-1 py-4 md:px-8">
            {!inviteId && <JoinOrganization />}
            {inviteId && <JoinOrganizationFromInvite inviteID={inviteId} />}
        </div>
    );
};
